<template>
  <v-app standalone :class="[$root.isRTL ? 'RLT' : '']">
    <transition name="slide-right">
      <div :class="['mobileMenu', $root.activeMobileMenu ? 'activeMenu' : '']">
        <SubMenu></SubMenu>
      </div>
    </transition>
    <v-navigation-drawer v-model="$root.activeSubMenu" light :class="[$root.device.isTablet ? 'tabletMenu' : '', $root.isRTL ? 'navigation-drawer--right' : '', 'elevation-10']" style="padding: 0px; margin: 0px; z-index: 200;">
      <div style="overflow: hidden;">
        <v-toolbar style="background-color:#3A2D01; height: 200px;">
          <v-layout row wrap style="color:#fff; padding: 20px;">
            <v-flex md12 sm12>
              <b>{{plan.Name}}</b>
            </v-flex>
            <v-flex md12 sm12>
              &nbsp;
            </v-flex>
            <v-flex md6 sm6>
              <div style="text-align: right; width: 100%;">שם תוכנית עבודה:</div>
            </v-flex>
            <v-flex md6 sm6>
              <b style="text-align: left;">{{plan.Name}}</b>
            </v-flex>
            <v-flex md6 sm6>
              <div style="text-align: right; width: 100%;">תיאור:</div>
            </v-flex>
            <v-flex md6 sm6>
              <b style="text-align: left;">{{plan.Info}}</b>
            </v-flex>
            <v-flex md6 sm6>
              <div style="text-align: right; width: 100%;">פרויקט:</div>
            </v-flex>
            <v-flex md6 sm6>
              <b style="text-align: left;">{{plan.ProjectName}}</b>
            </v-flex>
          </v-layout>
        </v-toolbar>
        <v-navigation-drawer v-model="$root.activeSubMenu" right :class="['submenu', $root.device.isTablet ? 'tabletMenu' : '']" style="overflow: hidden; margin-bottom: 50px;">
          <v-list v-if="$root.device.isTablet">
            <v-list-tile @click.native="$root.goto('Plans');">
              <v-list-tile-content>
                <v-list-tile-title style="text-align: right!important; margin: 10px;">חזרה</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <i class="material-icons" style="cursor: pointer;" @click="$root.goto('Plans')" v-tooltip:bottom="{ html: 'הורדה' }">close</i>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <Folder class="rootFolder" isRoot="true" :Key="Object.keys(rootData)[0]" :folderData="rootData" :path="rootPath" :canEdit="canEdit"></Folder>
        </v-navigation-drawer>
      </div>
    </v-navigation-drawer>
    <v-container fluid style="z-index: 100;">
      <v-card :class="[$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']">
        <v-toolbar dark color="primary" class="fullToolbar">
          <v-toolbar-title v-if="$root.device.isMobile" class="white--text" style="font-size: 30px; text-align: right; width: 200px;">
            <i class="material-icons icon">picture_as_pdf</i>{{plan.Name}}
          </v-toolbar-title>
          <div v-else class="divDiary">
            <img class="logoDiary" src="../assets/yomanet.png" />
            <div class="diaryTitle">{{plan.Name}}</div>
          </div>
          <v-spacer v-if="!$root.device.isMobile"></v-spacer>
          <v-icon v-else @click="$root.activeMobileMenu=true" class="btnIcon mr-2 ml-2">menu</v-icon>
        </v-toolbar>
        <div v-if="$root.device.isMobile || $root.device.isTablet">
          <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
            <tr class="trPrint trHeader">
              <th>
                <div>שם תוכנית: <b>{{plan.Name}}</b></div>
                <div>תיאור: <b>{{plan.Info}}</b></div>
                <div>פרויקט: <b>{{plan.ProjectName}}</b></div>
              </th>
              <th v-if="$root.device.isMobile">
                <a @click="isFilesVisible=true" class="btnPlans">
                  <v-layout>
                    <v-flex xs3>
                      <i class="material-icons icon">find_in_page</i>
                    </v-flex>
                    <v-flex xs9>
                      <div style="font-weight: bold;">בחר תוכנית</div>
                    </v-flex>
                  </v-layout>
                </a>
              </th>
            </tr>
          </table>
          <PDFMobile :url="$root.selectedFile" style="width: 100%; height: 100%;"></PDFMobile>
        </div>
        <div v-else class="divScroll">
          <PDF :url="$root.selectedFile" style="width: 100%; height: 100%;"></PDF>
        </div>
      </v-card>
    </v-container>
    <v-snackbar :timeout="$root.alert.timeout" :top="$root.alert.isTop" v-model="$root.alert.isShow">{{ $root.alert.message }}</v-snackbar>
    <PopupConfirm></PopupConfirm>
    <PopupAddFile></PopupAddFile>

    <v-dialog v-model="isFilesVisible" persistent>
      <v-card>
        <v-toolbar class="trHeader" style="height: 40px;">
          <v-toolbar-title class="white--text" style="text-align:center;">בחר קובץ</v-toolbar-title>
        </v-toolbar>
        <v-flex>
          <Folder class="rootFolder" isRoot="true" :Key="Object.keys(rootData)[0]" :folderData="rootData" :path="rootPath" :canEdit="canEdit"></Folder>
        </v-flex>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
  import { db } from '../firebase';
  import PDF from '../components/PDF';
  import PDFMobile from '../components/PDFMobile';
  import Folder from '../components/Folder';
  import PopupConfirm from '../components/PopupConfim';
  import PopupAddFile from '../components/PopupAddFile';
  import SubMenu from '../components/SubMenu';

  export default {
    name: 'Plan',
    components: { SubMenu, PDF, PDFMobile, Folder, PopupConfirm, PopupAddFile },
    data() {
      return {
        isFilesVisible: false,
        treeData: null,
        rootFolder: {
          Title: "משפחת מורן-08",
          Key: "Root",
          SubFolders: [
            {
              Title: "אדריכלות",
              Key: 1,
              SubFolders: [],
              Files: [
                { Key: 0, Title: 'Document 04Document 04Document 04', Url: 'tttttttt04' },
                { Key: 0, Title: 'Document 05', Url: 'tttttttt05' },
                { Key: 0, Title: 'Document 06', Url: 'tttttttt06' }
              ]
            },
            {
              Title: "ביוב ומים",
              Key: 2,
              SubFolders: [
                {
                  Title: "אלומיניום",
                  Key: 9,
                  SubFolders: [],
                  Files: [
                    { Key: 0, Title: 'Document 99Document 99Document 99', Url: 'tttttttt04' },
                    { Key: 0, Title: 'Document 99', Url: 'tttttttt05' },
                    { Key: 0, Title: 'Document 99', Url: 'tttttttt06' }
                  ]
                },
              ],
              Files: [
                { Key: 0, Title: 'DocumentDocumentDocument 07', Url: 'tttttttt07' },
                { Key: 0, Title: 'Document 08', Url: 'tttttttt08' },
                { Key: 0, Title: 'Document 09', Url: 'tttttttt09' }
              ]
            }
          ],
          Files: [
            { Title: 'Document 01', Url: 'tttttttt01' },
            { Title: 'Document 02', Url: 'tttttttt02' },
            { Title: 'Document 03', Url: 'tttttttt03' }
          ]
        },
        plan: {
          Name: '',
          Info: '',
          ProjectName: '',
        },
        rootData: null,
        planFilesTree: [],
      }
    },
    created() {
      this.$Log("Vue [Plan] is created ...");
    },
    ready() {
      this.$Log("Vue [Plan] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Plan] is mounted ...");
      this.loadData();
      this.loadFiles();
      this.$root.selectedFile = '';
    },
    updated() {
      this.$Log("Vue [Plan] is updated ...");
    },
    computed: {
      rootPath() {
        return "PlaneFiles/" + this.$route.params.planKey + "/Root/";
      },
      canEdit() {
        if (this.$root.isAdmin) {
          return true;
        }
        else {
          return (this.plan.UserKey == this.$root.user['.key']);
        }
      }
    },
    watch: {
      '$root.selectedFile'(val) {
        this.isFilesVisible = false;
      },
      '$root.isUpdatedPlan'(val) {
        if (val) {
          this.loadFiles();
          this.$root.isUpdatedPlan = false;
        }
      }
    },
    methods: {
      getStatus() {
        return "TEST";
      },
      loadData() {
        var vm = this;
        var plansRef = db.ref('Plans').orderByKey().equalTo(vm.$route.params.planKey).once('value').then(function (snapPlan) {
          var obj = snapPlan.val();
          if (obj) {
            var key = Object.keys(obj)[0];
            let p = obj[key];
            p['.key'] = key;
            vm.plan = p;
          }
        });
      },
      loadFiles() {
        var vm = this;
        var planeFilesRef = db.ref('PlaneFiles/' + vm.$route.params.planKey).once('value').then(function (snapPlanFiles) {
          vm.planFilesTree = snapPlanFiles.val();
          //vm.diary['.key'] = vm.$route.params.diaryKey;
          var objTree = snapPlanFiles.val();
          //vm.planFilesTree = {};
          if (objTree) {
            //vm.rootData = objTree.Root;
            //vm.rootData.Key = "Root";

            vm.rootData = objTree;


            //vm.planFilesTree = objTree;

            //vm.planFilesTree = {
            //  IsRoot: true,
            //  Title: objTree.Root.Title,
            //  Files: [],
            //}

            //if (objTree.Root.Files) {
            //  var fileKeys = Object.keys(objTree.Root.Files);
            //  for (var l = 0; l < fileKeys.length; l++) {
            //    let k = fileKeys[l];
            //    vm.planFilesTree.Files.push(objTree.Root.Files[k]);
            //  }
            //}

          }
        });
      },
    }
  }

</script>
<style>
  .rootFolder {
    margin-top: 20px;
    direction: rtl;
    margin-right: -5px!important;
  }

  .divDiary {
    width: 400px;
    text-align: right;
    padding-right: 10px;
    float: right;
  }

  .logoDiary {
    width: 70px;
    height: 70px;
    float: right;
  }

  .diaryTitle {
    padding-right: 10px;
    line-height: 70px;
    font-size: 30px;
    float: right;
  }

  .fe_forecast {
  }

    .fe_forecast > div.fe_currently {
    }

  #fe_current_icon {
    width: 30px !important;
    height: 30px !important;
  }

  .fe_temp {
    font-size: 20px !important;
  }

  .fe_dir {
    display: none;
  }

  .fe_forecast > div.fe_currently > div.fe_temp {
  }

  .fe_forecast > div.fe_daily {
    display: none;
  }

  .fe_summary {
    display: none;
  }

  .fe_wind {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// Plan.vue?41187fed